// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"a6df276f","391":"d7f1c635","453":"db891a34"}[chunkId] + ".chunk.js";
};